<div class="collab-banner sticky-header-banner banner-sec relative">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative pb-0">
            <div class="text-center z-index pb-2">

                <!-- <div class="mx-auto whats-new-label banner-wts-new-label">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div> 
                    <span class="paragraph-global-text sub-head-paragraph secondary-gradient-text">
                        {{'collaboration_School.banner.preTitle' | translate}}
                    </span>
                </div> -->

                <h1 class="banner-heading mx-auto secondary-gradient-text">{{tutprial.title}}</h1>
                <p class="paragraph-global-text mw-800 text-whitish-gray">{{tutprial.description}}</p>
                <div class="mt-5 mb-5 mx-auto button-container">                    
                    <a class="save-btn btn cfa" [routerLink]="'/en/collaboration-school'"> <i class="pi pi-arrow-left title-color mr-2"></i> View all tutorials</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="sec-padding">    
    <div class="container z-index">
        <div class="row">
            <div class="col-lg-3 col-sm-12">
                <div class="lft-sticky-section">
                    <p class="paragraph-global-text d-block cursor-pointer" *ngFor="let sec of tutprial.table_of_contents;let i = index" (click)="scrollTo('section_'+ i)">
                    <span>{{sec}}</span>
                </p>
                </div>
            </div>

            <div class="col-lg-9 col-sm-12">
                 <!-- cards  -->
                 <div class="div-video-content-width">
                    <h1 class="heading-one">{{tutprial.title}}</h1>
                    <p class="paragraph-global-text">{{tutprial.description}}</p>
                    <div class="social-icons my-4">
                        <ul class="no-flex-wrap">
                        <li>
                            <a href="{{sharedService.twitter}}" target="_blank">
                            <i class="fa-brands fa fa-x-twitter"></i>
                            </a>
                        </li>
                        <li>
                            <a href="{{sharedService.youtube}}" target="_blank">
                            <i class="fa-brands fa fa-youtube"></i>
                            </a>
                        </li>
                        <li>
                            <a href="{{sharedService.facebook}}" target="_blank">
                            <i class="fa-brands fa fa-facebook-f"></i>
                            </a>
                        </li>
                        <li>
                            <a href="{{sharedService.instagram}}" target="_blank">
                            <i class="fa-brands fa fa-instagram"></i>
                            </a>
                        </li>
                        <li>
                            <a href="{{sharedService.linkedin}}" target="_blank">
                            <i class="fa-brands fa fa-linkedin"></i></a>
                        </li>
                
                        <li>
                            <a href="{{sharedService.medium}}" target="_blank"><i class="fa-brands fa fa-medium"></i></a>
                        </li>
                
                        </ul>
                    </div>
                    <img class="w-100 my-5" src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80" alt="">
                    <p class="paragraph-global-text">{{tutprial.introduction.text}}</p>

                    <div class="mt-5 mb-5 mx-auto button-container justify-content-start">                    
                        <a class="save-btn btn cfa" [routerLink]="'/en/collaboration-school'"> <i class="pi pi-arrow-left title-color mr-2"></i> View all tutorials</a>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</div>

<div class="sec-padding cfa-sec position-relative">    
    <div class="cfa-grid"></div>
  <div class="container z-index">
      <div class="sec-title text-center">
          <h2 class="heading-one text-white mx-auto">{{'collaboration_School.cfa.title' | translate}} </h2>
          <p class="paragraph-global-text sub-head-paragraph mw-750 text-white">{{'collaboration_School.cfa.description' | translate}}</p>

          <div class="button-container mt-4">
              <a class="save-btn cfa btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                {{'collaboration_School.cfa.btnText' | translate}}
              </a>
          </div>
      </div>
  </div>
</div>